import { ApiJob } from 'modules/listing/api/job/types/ApiJob';
import { ListingViewSidebar } from 'modules/listing/components/ListingView/Sidebar/ListingViewSidebar';
import { ListingViewSidebarContent } from 'modules/listing/components/ListingView/Sidebar/ListingViewSidebarContent';
import { ListingViewSidebarImage } from 'modules/listing/components/ListingView/Sidebar/ListingViewSidebarImage';
import { ListingViewSidebarLinks } from 'modules/listing/components/ListingView/Sidebar/ListingViewSidebarLinks';
import { ListingViewSidebarTitle } from 'modules/listing/components/ListingView/Sidebar/ListingViewSidebarTitle';
import { SearchContextHeaderData } from 'modules/search/containers/SearchContextHeader/SearchContextHeaderData';

import { ViewJobPageSidebarResults } from './ViewJobPageSidebarResults';

type Props = {
  job: ApiJob;
  orgName: string | undefined;
  listingDetailsSearchResultsEnabled: boolean;
  searchContext: SearchContextHeaderData | null | undefined;
  isExpired: boolean;
};

export function ViewJobPageSidebar({
  job,
  orgName,
  listingDetailsSearchResultsEnabled,
  searchContext,
  isExpired,
}: Props) {
  const {
    address,
    id,
    hasAts,
    org,
    firstPublished,
    isPostedAnonymously,
    name,
    type,
    remoteOptions,
    hasOrgNameOverride,
    orgLogoOverride,
  } = job;

  if (listingDetailsSearchResultsEnabled) {
    return (
      <ListingViewSidebar>
        <ViewJobPageSidebarResults job={job} searchContext={searchContext} />
      </ListingViewSidebar>
    );
  }

  return (
    <ListingViewSidebar maxWidth={288}>
      <ListingViewSidebarImage
        isPostedAnonymously={isPostedAnonymously}
        orgLogo={org?.logo}
        orgLogoOverride={orgLogoOverride}
        orgURLForCurrentLocale={
          org?.url?.[CURRENT_LOCALE()] ? org?.url[CURRENT_LOCALE()] : undefined
        }
        orgName={orgName}
      />

      <ListingViewSidebarTitle
        address={address}
        listingName={name}
        listingType={type}
        orgName={orgName}
        orgUrl={hasOrgNameOverride || isPostedAnonymously ? null : org?.url}
        remoteOptions={remoteOptions}
      />

      <ListingViewSidebarContent
        firstPublished={firstPublished}
        listingId={id}
        listingType={type}
        hasAts={hasAts}
        isExpired={isExpired}
      />

      <ListingViewSidebarLinks
        searchContext={searchContext}
        orgUrl={hasOrgNameOverride || isPostedAnonymously ? null : org?.url}
      />
    </ListingViewSidebar>
  );
}
